import React, { useContext, useEffect, useState } from "react";
import Modal from "react-modal";
import { ModalContext } from "../contexts/ModalContext";
import { Context } from "../contexts/AppContext";
import NewGalleryCreateP from "../PropertyList/NewGalleryCreateP";
import { postData, putData } from "../../lib/utils";
import { useNavigate } from "react-router-dom";
import RenameCreateP from "../PropertyList/RenameCreateP";
function RenameModal() {

  const navigate = useNavigate();
  const [fileName, setFileName] = useState(null);
 

 
  const { value } = useContext(Context);
  const [appState, setAppState] = value;
  const [modalOpen, setModalOpen] = useState(appState.modalData);
 
 
  Modal.setAppElement("#root");

   useEffect(() => {
     setModalOpen(appState.modalData); // modalOpen को अपडेट करें
   }, [appState.modalData]);
    

  const customStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      maxWidth: "300px",
      height: "auto",
      width: "100%",
      overflow: "hidden",
      border:"1px solid #00bcd4",
      borderRadius:"10px"
    },
    overlay: {
      backgroundColor: "rgba(0, 0, 0, 0.2)",
    },
  };

  const closeModal = () =>  { 
    setAppState((prevState) => {
      return { ...prevState, 
        modalData:{ ...prevState.modalData, type: null, isOpen: false, folderUpdate:true}};
    }); 
    }

  const btnHandler = async (type) => {
console.log('appState')

 
 
    
    if (type === "save" && fileName) {
      
      if(appState.modalData.type==="RenameModal"){
        const response = await putData(`folder/folders/${appState.currentFolderData._id}`,{
          name: fileName,
         });
         if (response) {
          console.log("RESPONSE ",response)
          closeModal();
         // window.location.reload();
         
        }
      
      }
      if(appState.modalData.type==="RenameGalleryModal"){
        const response = await putData(`galleries/galleries/${appState.currentDBGalleryId}`,{
          name: fileName,
         });
         if (response) {
          console.log("RESPONSE ",response)
          closeModal();
         // window.location.reload();
        }
      
      }

        
       
    
    } else {
      closeModal();
    }
  };

  return (
    <Modal isOpen={modalOpen.isOpen} onRequestClose={closeModal} style={customStyles}>
      <RenameCreateP updateGalleryData={setFileName} />
      <div className="w-full flex justify-around mt-10">
        <button
          onClick={() => btnHandler("cancel")}
          className="text-white bg-gray-500 hover:bg-gray-700 focus:ring-4 focus:outline-none font-medium rounded-lg text-sm px-5 py-2.5"
        >
          Cancel
        </button>
        <button
          onClick={() => btnHandler("save")}
          className="text-white bg-gray-500 hover:bg-gray-700 focus:ring-4 focus:outline-none font-medium rounded-lg text-sm px-5 py-2.5"
        >
          Save
        </button>
      </div>
    </Modal>
  );
}

export default RenameModal;
